<template>
  <u-dashboard-toolbar />
  <u-dashboard-panel-content>
    <template v-if="auth.user && auth.isStripeVerified">
      <app-banner>
        <p>You are a registered event organizer.</p>
        <p>
          Your Stripe Connect ID is:
          <span class="font-bold">{{ auth.user.stripe_connect_id }}</span>
        </p>
        <p>
          <u-button
            variant="link"
            aria-label="Stripe Connect Account"
            class="p-0"
            @click="openStripeAccount"
          >
            Manage Stripe Connect
          </u-button>
          &middot;
          <u-button
            variant="link"
            aria-label="Open Stripe Express"
            to="https://connect.stripe.com/app/express#balances"
            target="__blank"
            rel="noopener noreferrer"
            class="p-0"
          >
            Open Stripe Express
          </u-button>
        </p>
      </app-banner>
      <!-- TODO: Support discount codes
      <br />
      <app-banner>
        If you manage a small event, you may be eligible for a reduced fee for you and
        your exhibitors. We offer discount codes for events so that you can use our
        service for a reduced cost or, in some cases, for free! Please contact us at
        <u-button
          variant="link"
          to="mailto:support@theshowportal.com?subject=Discount%20Code%20Request"
          target="__blank"
          rel="noopener noreferrer"
          class="p-0">
          support@theshowportal.com
        </u-button>
        to request a discount code.
      </app-banner> -->
    </template>
    <app-banner v-else-if="typeof auth.user?.stripe_connect_id === 'string'">
      <p>You're on your way to becoming an event organizer!</p>
      <p>
        Your Stripe Connect account is not fully setup or is awaiting verification. You
        can update your Stripe Connect account at any time by clicking
        <!-- eslint-disable prettier/prettier -->
        <u-button
          variant="link"
          aria-label="Stripe Connected Account"
          class="p-0"
          @click="openStripeAccount"
        >
          this link
        </u-button>.
        <!-- eslint-enable prettier/prettier -->
      </p>
      <p>
        Your Stripe Connect ID is
        <span class="font-bold">{{ auth.user.stripe_connect_id }}</span>
      </p>
    </app-banner>
    <app-banner v-else>
      <h5>Become an Event Organizer</h5>
      <p>
        By completing the event organizer setup, you acknowledge that you have permission
        to act as the financial representative on behalf of your organization or business.
        You must also agree to our
        <!-- eslint-disable prettier/prettier -->
        <u-button
          variant="link"
          to="/terms"
          target="__blank"
          rel="noopener noreferrer"
          aria-label="Terms"
          class="p-0"
        >
          Terms
        </u-button>,
        <u-button
          variant="link"
          to="/privacy-policy"
          target="__blank"
          rel="noopener noreferrer"
          aria-label="Privacy Policy"
          class="p-0"
        >
          Privacy Policy
        </u-button>, as well as the
        <u-button
          variant="link"
          to="https://stripe.com/legal/connect-account"
          target="__blank"
          rel="noopener noreferrer"
          aria-label="Stripe Connected Account Agreement"
          class="p-0"
        >
          Stripe Connected Account Agreement
        </u-button>.
        <!-- eslint-enable prettier/prettier -->
      </p>
      <u-button
        type="submit"
        class="w-fit"
        :disabled="app.state.isLoading"
        :loading="app.state.isLoading"
        @click="openStripeAccount"
      >
        Continue with Stripe
      </u-button>
    </app-banner>
  </u-dashboard-panel-content>
</template>

<script lang="ts" setup>
definePageMeta({
  middleware: ['auth'],
})

useHead({
  title: 'The Show Portal',
})

const app = useApp()
const auth = useAuth()

app.data.title = 'Stripe Connect'

/**
 * Open the current or new Stripe account.
 */
async function openStripeAccount() {
  try {
    app.state.isLoading = true

    await toStripeAccount()
  }
  catch (error) {
    console.error(error)
  }
  finally {
    app.state.isLoading = false
  }
}
</script>
